/**
 * The start date used for "All Time" analytics queries.
 * Centralized here so frontend and backend use the same boundary.
 */
export const ALL_TIME_START_DATE = new Date(2026, 0, 1); // January 1, 2026
